import { inject } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { Router, Routes } from "@angular/router";
import { filter, fromEvent, map, Observable, startWith } from "rxjs";
import { environment } from "src/environments/environment";
import { RoleType } from "./api/client";
import { e2eTokenStorageKey } from "./core/consts/storage-keys";
import { EnvironmentId } from "./core/enums/environment-id.enum";
import { concatCanActivateFn } from "./core/functions/concat-guards";
import { authGuard } from "./core/guards/auth.guard";
import { currentUserDataGuard } from "./core/guards/current-user-data.guard";
import { roleGuard } from "./core/guards/role.guard";

export const routes: Routes = [
  {
    path: "unauthorized",
    title: "Unauthorized",
    loadComponent: () => import("./core/unauthorized/unauthorized.component").then((c) => c.UnauthorizedComponent),
  },
  {
    // Route to handle e2e test authentication
    path: "e2e",
    title: "TABA - Trusted-as-built Assets",
    runGuardsAndResolvers: "always",
    children: [],
    canMatch: [() => environment.id !== EnvironmentId.Production],
    canActivate: [
      (route) => {
        const router = inject(Router);
        return (<Observable<StorageEvent>>fromEvent(window, "storage")).pipe(
          startWith(undefined),
          filter(() => Boolean(sessionStorage.getItem(e2eTokenStorageKey))),
          map(() => router.createUrlTree(["/"], { queryParams: route.queryParams, fragment: route.fragment || undefined })),
          takeUntilDestroyed()
        );
      },
    ],
  },
  {
    path: "version",
    title: "TABA - Trusted-as-built Assets",
    loadComponent: () => import("./version/version.component").then((c) => c.VersionComponent),
  },
  {
    path: "",
    title: "TABA - Trusted-as-built Assets",
    canActivate: [concatCanActivateFn(authGuard, currentUserDataGuard, roleGuard(RoleType.Taba_user))],
    loadComponent: () => import("./core/layouts/main-layout/main-layout").then((m) => m.MainLayout),
    loadChildren: () => [
      {
        path: "technical-asset",
        loadChildren: () => import("./technical-asset/technical-asset.routes").then((m) => m.technicalAssetRoutes),
      },
      {
        path: "user-management",
        canActivate: [roleGuard(RoleType.User_manager)],
        loadChildren: () => import("./user-management/user-management.routes").then((m) => m.userManagementRoutes),
      },
      { path: "", loadComponent: () => import("./homepage/homepage").then((c) => c.Homepage) },
    ],
  },
];
